import dom from '@/util/dom';
import anime from 'animejs';

var tpl = `<div class="cp-loading cp-loading--start fs-14">
    <div class="loadingIcon_sun">
        <svg width="80" height="80" viewBox="-50 -50 220 220" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" >
            <g transform="translate(32, 32) rotate(270, 28, 28)">
                <path fill="none" stroke="#FFD74F" stroke-width="8" stroke-linecap="round" d="M28.26,3.99 C15.09,3.99 4.41,14.74 4.41,28 C4.41,41.26 15.09,52.01 28.26,52.01 C41.43,52.01 52.11,41.26 52.11,28" class="loading-svg__path"></path>
            </g>

            <g fill="#FFD74F" transform="translate(12, 5)">
                <path class="loading-svg__sun" d="M48.26,26 C64.28,26 77.26,38.98 77.26,55 C77.26,71.02 64.28,84 48.26,84 C32.24,84 19.26,71.02 19.26,55 C19.26,38.98 32.24,26 48.26,26 Z M48.26,15.94 C45.55,15.94 43.35,13.73 43.35,11 L43.35,4.94 C43.35,2.21 45.55,-0 48.26,-0 C50.97,-0 53.17,2.21 53.17,4.94 L53.17,11 C53.17,13.73 50.97,15.94 48.26,15.94 Z M48.26,94 C50.97,94 53.17,96.21 53.17,98.94 L53.17,105 C53.17,107.73 50.97,109.94 48.26,109.94 C45.55,109.94 43.35,107.73 43.35,105 L43.35,98.94 C43.35,96.21 45.55,94 48.26,94 Z M12.64,28.74 C15,30.1 15.81,33.11 14.46,35.46 C13.11,37.8 10.09,38.6 7.73,37.24 L2.48,34.2 C0.12,32.84 -0.7,29.83 0.65,27.49 C2.01,25.14 5.02,24.34 7.38,25.71 L12.64,28.74 Z M94.04,75.74 C96.41,77.1 97.22,80.11 95.87,82.46 C94.51,84.8 91.5,85.6 89.14,84.23 L83.88,81.2 C81.52,79.84 80.71,76.83 82.06,74.48 C83.42,72.14 86.43,71.34 88.79,72.71 L94.04,75.74 Z M7.73,72.71 C10.09,71.34 13.11,72.14 14.46,74.48 C15.81,76.83 15,79.84 12.64,81.2 L7.38,84.23 C5.02,85.6 2.01,84.8 0.65,82.46 C-0.7,80.11 0.12,77.1 2.48,75.74 L7.73,72.71 Z M88.79,37.24 C86.43,38.6 83.41,37.8 82.06,35.46 C80.71,33.11 81.52,30.1 83.88,28.74 L89.14,25.71 C91.5,24.34 94.51,25.14 95.87,27.49 C97.22,29.83 96.4,32.84 94.04,34.2 L88.79,37.24 Z" transform="scale(0)"></path>
            </g>
            <!-- <line x1="60" y1="0" x2="60" y2="120" style="stroke:rgb(99,99,99);stroke-width:1" /> -->
            <!-- <line x1="0" y1="60" x2="120" y2="60" style="stroke:rgb(99,99,99);stroke-width:1" /> -->
        </svg>
    </div>
<span>{{}}</span></div>`;
var activeToast = [];


function startAnimation($el) {
    var sun = $el.querySelector('.loading-svg__sun'),
        line = $el.querySelector('.loading-svg__path'),
        // lineCenter = ` ${(line.getBBox().width + 8) / 2}`, // 8是stroke-width
        // sunInfo = sun.getBBox(),
        sunInfo = {width: 96, height: 110},
        sunObj = {r: 0, s: 0},
        currentAnime;

    // lineCenter += lineCenter + ')';

    startOneCycle();

    function startOneCycle() {
        currentAnime = anime({
            targets: line,
            strokeDashoffset: [path => anime.setDashoffset(path) / 2, path => -(anime.setDashoffset(path))],
            update(e) {
                e.animatables[0].target.setAttribute('transform', 'rotate(-' + (e.progress * 720 / 100) + ' 28 28)')
                // e.animatables[0].target.setAttribute('transform', 'rotate(-' + (e.progress * 720 / 100) + lineCenter)
            },

            duration: 1000,
            easing: 'linear',
            elasticity: 0
        });

        return currentAnime.finished.then(function() {
            currentAnime = anime({
                targets: sunObj,
                s: 1,

                duration: 400,
                easing: 'linear',
                elasticity: 0,
                update(e) {
                    var progress = e.progress / 100;

                    sun.setAttribute('transform', `translate(${(1-progress)*sunInfo.width/2} ${(1-progress)*sunInfo.height/2}) scale(${progress})`);
                    // sun.setAttribute('transform', `translate(${(1-progress)*sunInfo.width/2} ${(1-progress)*sunInfo.height/2}) scale(${progress})`);
                }
            });

            return currentAnime.finished
        })
            .then(function() {
                currentAnime = anime({
                    targets: sunObj,
                    r: 300,

                    // loop: true,
                    duration: 2400,
                    easing: 'linear',
                    elasticity: 0,
                    update(e) {
                        sun.setAttribute('transform', `rotate(${sunObj.r} ${sunInfo.width/2} ${sunInfo.height/2})`)
                    }
                });

                return currentAnime.finished
            })
            .then(function() {
                sunObj.r = 0;
                sunObj.s = 0;
                sun.setAttribute('transform', 'scale(0)');

                startOneCycle();
            })
    }

    return currentAnime;
}
/**
 * 创建一个toast
 * @param  {String} content toast内容的html
 * @param  {Number} time    toast持续的时间
 * @param  {String} id      toast的id，如果堆栈存在一样的id，则不会新建toast
 */
export default function(content, time, id) {
    if (arguments.length == 2 && typeof time == 'string') {
        id = time;
        time = 3000;
    }

    if (id) {
        if (activeToast.indexOf(id) !== -1) return;
        activeToast.push(id);
    }

    var $loading = dom.create(tpl.replace('{{}}', content));


    time = time || 3000;

    document.body.appendChild($loading);
    var Anima = startAnimation($loading)
    $loading.clientHeight;
    $loading.classList.remove('cp-loading--start');

    setTimeout(function() {
        $loading.classList.add('cp-loading--close');
        id && activeToast.splice(activeToast.indexOf(id), 1);
        Anima && Anima.pause();
        Anima = null;
        setTimeout(function () {
            $loading.parentNode.removeChild($loading);
        }, 300);
    }, time);
}



// WEBPACK FOOTER //
// ./src/lib/loading.js